import React from "react";

export default function C_V_USER({ value, user }) {
  const displayName = user?.full_name || user?.name || value;
  const smallAvatar =
    user?.profile_picture?.url_compressed || user?.profile_picture?.url;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        width: "100%",
        height: "100%",
        overflow: "hidden",
      }}
      title={displayName}
    >
      {smallAvatar ? (
        <img
          src={smallAvatar}
          alt={displayName}
          style={{
            width: "19px",
            height: "19px",
            borderRadius: "50%",
            objectFit: "cover",
            flexShrink: 0,
            border: "1px solid #e5e7eb",
          }}
        />
      ) : (
        <div
          style={{
            width: "19px",
            height: "19px",
            borderRadius: "50%",
            backgroundColor: "#f3f4f6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "10px",
            fontWeight: "bold",
            color: "#6b7280",
            flexShrink: 0,
          }}
        >
          {displayName?.charAt(0)?.toUpperCase() || "?"}
        </div>
      )}

      <span
        style={{
          display: "block",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          width: "100%",
          lineHeight: "1.5",
        }}
      >
        {displayName}
      </span>
    </div>
  );
}
